import { isAudio, isFile } from 'components/uploaded-images/helpers';
import dayjs from 'dayjs';
import { capitalize } from 'lodash';
import { createContent, isContentEmpty } from 'utils/helpers';
import { firstAddressHelper } from 'utils/helpers/firstAddressHelper';
import { IProjectShort } from 'redux-store/api/projects';
import {
  ActivityFeedDraftTypeEnum,
  TActivityFeedDraftItem,
  TActivityFeedDraftItemUploads,
} from 'redux-store/api/activity-feed';

export const getProjectLocation = (project: IProjectShort): string => {
  if (!project) return '';

  const firstAddress = firstAddressHelper(project?.address);
  const address = firstAddress || '';
  const city = project?.city;
  const zip = project?.zip;
  const extraAddress = project.address?.split(',')?.[3] || '';

  return `${address}, ${city}, ${zip} ${extraAddress}`.trim();
};

export const getDraftDetails = ({
  draft,
  allProjects,
  activePostDraftId,
}: {
  draft: TActivityFeedDraftItem;
  allProjects: IProjectShort[];
  activePostDraftId: number;
}) => {
  const content = createContent(draft.data.content, draft.data.mentions);
  const uploads = draft.data.uploads;
  const media: TActivityFeedDraftItemUploads = uploads.filter(
    ({ mimeType, name }) => !isFile(name) && !isAudio(mimeType)
  );
  const project = allProjects?.find((p) => p.id === draft.projectId);
  const postfix = capitalize(draft.type);
  const formattedCreatedAt = dayjs(draft.createdAt).format('MMM D / h:mm A');

  const hasMedia = media.length > 0;
  const hasContent = content && !isContentEmpty(content);
  const hasMediaOrContent = hasMedia || hasContent;

  const isDraftActive =
    draft.type === ActivityFeedDraftTypeEnum.POST && activePostDraftId === draft.id;

  const completePrefix = isDraftActive ? 'Continue' : 'Complete';

  return {
    content,
    media,
    hasMedia,
    hasContent,
    hasMediaOrContent,
    postfix,
    project: {
      name: project?.name,
      location: getProjectLocation(project),
      createdAt: formattedCreatedAt,
    },
    uploads,
    completePrefix,
    isDraftActive,
  };
};
